<template>
  <v-dialog v-model="isOpenDialog" width="620px" scrollable class="color">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">Chi tiết bảng lương</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text id="element-to-convert">
        <TeacherInfo />
        <BillReportExcel />
        <div class="summary_wrap" v-if="period.status !== 'created'">
          <div class="summary_final">
            <p>Tổng kết cuối:</p>
            <span>{{ period.updatedAt | ddmmyyyyhhmm }}</span>
          </div>
          <div class="summary_people">
            <p>Người tổng kết:</p>
            <span>{{ get(period, 'generatedBy.name', '') }}</span>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn
          depressed
          color="primary"
          class="px-6 mr-2 mt-n4 mb-2 white--text d-none text-uppercase"
          @click="exportPdf"
        >
          XUẤT FILE PDF
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import html2pdf from 'html2pdf.js'
import BillReportExcel from './BillReportExcel.vue'
import TeacherInfo from './TeacherInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
export default {
  components: {
    TeacherInfo,
    BillReportExcel
  },
  data() {
    return {
      isOpenDialog: false,
      loading: false,
      get
    }
  },
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period',
      report: 'salaryReport/report'
    })
  },
  methods: {
    ...mapActions('salaryReport', ['summaryOne', 'fetchOne']),
    async openDialog() {
      try {
        this.$loading.active = true
        await this.fetchOne(this.report.id)
        this.isOpenDialog = true
      } catch (error) {
        this.$alert.error(error)
        this.cancel()
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.isOpenDialog = false
    },
    exportPdf() {
      const convertFullDate = this.$options.filters.convertFullDate(this.period.title)
      const name = get(this.report, 'teacher.name')
      const phone = get(this.report, 'teacher.phone')
      html2pdf(document.getElementById('element-to-convert'), {
        filename: `BL ${name}_${phone}_${convertFullDate}.pdf`
      })
    }
  }
}
</script>
<style lang="scss">
#element-to-convert {
  font-family: 'Roboto';
}

.margin {
  margin: 10px 0;
}

.summary_wrap > .summary_final,
.summary_people {
  display: flex;
  margin: 12px 12px 12px 20px;
}

.summary_wrap > .summary_final p,
.summary_people p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 8px 0 0;
}

.total_money {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.total_money h3,
.total_money span {
  color: #fd6b6b;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
</style>
